import { render, staticRenderFns } from "./game-course-diagram-data.vue?vue&type=template&id=34678e92&scoped=true"
import script from "./game-course-diagram-data.vue?vue&type=script&lang=js"
export * from "./game-course-diagram-data.vue?vue&type=script&lang=js"
import style0 from "./game-course-diagram-data.vue?vue&type=style&index=0&id=34678e92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34678e92",
  null
  
)

export default component.exports